module.exports = __webpack_public_path__ + "static/Imagem2-0d4436c7be566a752e71ea4d854f94ac.png";